import * as React from 'react';

const VideoChatIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={15}>
    <path
      fill={fillColor}
      d="M2.085 14.414A2.07 2.07 0 0 1 0 12.365V2.048A2.07 2.07 0 0 1 2.085 0h9.235a2.07 2.07 0 0 1 2.088 2.048v10.317a2.07 2.07 0 0 1-2.088 2.049H2.085Zm0-13.265a.908.908 0 0 0-.913.9v10.316a.904.904 0 0 0 .913.9h9.235a.91.91 0 0 0 .915-.9V2.048a.907.907 0 0 0-.915-.9l-9.235.001Zm15.736 12.542a.578.578 0 0 1-.285-.075l-3.238-1.844a.413.413 0 0 1-.153-.56l.153-.263a.442.442 0 0 1 .597-.158l2.1 1.191h.08l.125-.07.04-.07V2.596l-.04-.067-.125-.075h-.08l-2.126 1.192a.432.432 0 0 1-.57-.154l-.163-.28a.404.404 0 0 1 .151-.56L17.512.824a.622.622 0 0 1 .314-.093h.04a.582.582 0 0 1 .547.575v11.768a.605.605 0 0 1-.593.617h.001Z"
    />
  </svg>
);

export default VideoChatIcon;
